import { render, staticRenderFns } from "./ModifyRequestList.vue?vue&type=template&id=4c37c2f8&scoped=true&"
import script from "./ModifyRequestList.vue?vue&type=script&lang=js&"
export * from "./ModifyRequestList.vue?vue&type=script&lang=js&"
import style0 from "./ModifyRequestList.vue?vue&type=style&index=0&id=4c37c2f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c37c2f8",
  null
  
)

export default component.exports